import { render, staticRenderFns } from "./QNADetail.vue?vue&type=template&id=0ad85e9a&scoped=true"
import script from "./QNADetail.vue?vue&type=script&lang=js"
export * from "./QNADetail.vue?vue&type=script&lang=js"
import style0 from "./QNADetail.vue?vue&type=style&index=0&id=0ad85e9a&prod&scoped=true&lang=scss"
import style1 from "./QNADetail.vue?vue&type=style&index=1&id=0ad85e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad85e9a",
  null
  
)

export default component.exports